import { useEffect, useState } from "react";
import useIsIntegrated from "./useIsIntegrated";

const TICKETING_SYSTEMS = ["jira", "asana", "servicenow"];

function useTicketingIntegrations() {
  const { integrations, isIntegratedLoading } = useIsIntegrated();
  const [ticketingIntegrations, setTicketingIntegrations] = useState({
    isJiraIntegrated: false,
    isAsanaIntegrated: false,
    isServiceNowIntegrated: false,
  });

  useEffect(() => {
    if (!isIntegratedLoading && integrations) {
      const integratedSystems = {};
      const integratedSystemsList = [];

      TICKETING_SYSTEMS.forEach((system) => {
        const isSystemIntegrated = integrations.includes(system);
        integratedSystems[system] = isSystemIntegrated;
        if (isSystemIntegrated) {
          integratedSystemsList.push(system);
        }
      });

      setTicketingIntegrations({
        isJiraIntegrated: integratedSystems.jira,
        isAsanaIntegrated: integratedSystems.asana,
        isServiceNowIntegrated: integratedSystems.servicenow,
      });
    }
  }, [integrations, isIntegratedLoading]);

  return {
    isJiraIntegrated: ticketingIntegrations.isJiraIntegrated,
    isAsanaIntegrated: ticketingIntegrations.isAsanaIntegrated,
    isServiceNowIntegrated: ticketingIntegrations.isServiceNowIntegrated,
    isLoading: isIntegratedLoading,
  };
}

export default useTicketingIntegrations;
